import { newToast } from '../components';
import useApi from '../utils/axios-pettitions';

export const useApiBackups = () => {
  const { runApi } = useApi();

  //Obtener configuración
  const GetAll = async () => {
    return runApi('Backups/GetAll', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else {
        return res.data;
      }
    });
  };

  const Create = async () => {
    return runApi('Backups/Create', 'POST', null, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else {
        newToast('SUCCESS', 'Backup creado correctamente', 3);
        return res.data;
      }
    });
  };

  return { GetAll, Create };
};
